<template>
  <el-main>
    <h2 class="text-3xl mb-8">Projects</h2>
    <el-alert
      title="Drag and drop projects to change their order"
      type="info"
      :closable="false"
      show-icon
      class="max-w-xl"
    />
    <draggable
      v-model="orderedProjects"
      tag="ul"
      class="mt-12 mb-20"
      @change="save"
    >
      <li
        v-for="project in orderedProjects"
        :key="project.id"
        class="item mt-4"
      >
        <router-link :to="`/admin/projects/${project.slug}`" class="text-xl">
          <i class="el-icon-edit el-icon--right"></i> {{ project.title }}
        </router-link>
      </li>
    </draggable>
    <el-divider />
    <el-row>
      <el-button type="success" @click="$router.push('/admin/projects/new')"
        ><i class="el-icon-plus" /> New Project</el-button
      >
    </el-row>
  </el-main>
</template>

<script>
import Draggable from 'vuedraggable'
import saveProjectsMutation from '@/admin/graphql/mutations/save-projects.gql'

export default {
  name: 'AdminProjectIndex',

  metaInfo: {
    title: 'Projects'
  },

  components: {
    Draggable
  },

  props: {
    projects: {
      default: () => [],
      type: Array
    }
  },

  data() {
    return {
      orderedProjects: []
    }
  },

  apollo: {
    $client: 'admin'
  },

  computed: {
    projectOrders() {
      const projects = this.orderedProjects
      return projects.map((p, i) => {
        return {
          title: p.title,
          slug: p.slug,
          order: i
        }
      })
    }
  },

  watch: {
    projects(projects) {
      this.orderedProjects = projects
    }
  },

  mounted() {
    this.orderedProjects = this.projects
  },

  methods: {
    async save() {
      const mutation = saveProjectsMutation
      const variables = { projects: this.projectOrders }
      await this.$apollo
        .mutate({ mutation, variables })
        .then(({ data }) => {
          const message = data.saveProjects
          this.$message({ message, type: 'success' })
          this.$bus.$emit('update-projects')
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err)
        })
    }
  }
}
</script>
